import { days } from "Components/Shared/constants";
import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const DaySelect = ({ label, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        clearable
        fluid
        search
        selection
        multiple
        options={days}
        placeholder='Select Day Of Week'
        name={field.name}
        defaultValue={field.value.map((dow: number) => dow.toString())}
        onChange={(event, { value }) => {
          helpers.setValue(value);
        }}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default DaySelect;
